var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurkinaFaso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95439 8.95438 1.52588e-05 20 1.52588e-05C31.0456 1.52588e-05 40 8.95439 40 20C39.1305 20 20 22.6087 20 22.6087L0 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.0435L21.5107 17.6934H26.4003L22.4447 20.5673L23.9554 25.2174L20 22.3436L16.0444 25.2174L17.5554 20.5673L13.5997 17.6934H18.4891L20 13.0435Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurkinaFaso);
export default __webpack_public_path__ + "static/media/burkina_faso.91aaa902f997174b716e65e0591e933c.svg";
export { ForwardRef as ReactComponent };